
import { Section2,SectionTitle,SectionTitle2,GradCard1,SliderCard1 } from "../components/reuseable";
import Carousel from "../components/reuseable/carousel";

import { useAuth } from "../app/context";

const EducationalJourney = () =>{
  const { isLoaded, education, translations,breakpoint } = useAuth();
  return(
    <Section2 id="education">
      <SectionTitle title={translations.education.title} ts="2"/>

      {!!isLoaded && <div className="block-full my-40 sm:my-48 text-left">
        <Carousel
          dragable= {true}
          dots= {true}
          autoplay= {true}
          autoplayHoverPause= {true}
          autoplayTimeout= {4000}
          smartSpeed= {500}
          responsive= {{
            0 : {items: 1,margin:24},
            768 : {items: 2,margin:24},
            992 : {items: 3,margin:32},
          }}
        >
        {education.items.map((item,index)=>{
            return <SliderCard1 className="gradient-bc-2c" key={index}>
            <h4 className="flex-row-full font-inter fw-600 fs-20 lh-24 color-header-2 mb-16">
              {item.emoji}
              <span className="color-highlight mx-8">●</span>
              {item.title}
            </h4>
            <div className="block-full font-inter fw-400 fs-16 lh-24 color-normal">{item.description}</div>
          </SliderCard1>
          })}
        </Carousel>
      </div>}

      {!!isLoaded && <SectionTitle2 title={translations.education.title2} ts="2"/>}

      {!!isLoaded && <div className="block-full max-w-900 mx-auto mt-40 sm:mt-48">
        {education.degree.map((item, i) => {

          let _leftSide = i % 2 === 0 || breakpoint < 768;
          return <div 
            key={i} 
            className="flex-row-full"
          >
            {!_leftSide && <div className="block-f50 shrink-0 none md:block">&nbsp;</div>}

            <div className="flex-row-full md:w-f50 pr-12 sm:pr-0">
              {!_leftSide && <div className="block-12 shrink-0">
                <div className="block-4  h-full absolute right-10 top-0 bg-highlight-2 shrink-0 z-index-10">&nbsp;</div>
                <div className="block-24 h-24 absolute right-0 top-48 bg-surface-2 br-full bw-4 bs-solid bc-highlight-2 shrink-0 z-index-20">&nbsp;</div>
              </div>}
              {!_leftSide && <div className="block-0 h-0 bw-y-12 bw-r-24 bs-solid bc-transparent shrink-0 mt-48 z-index-10" style={{"borderRightColor": "var(--surface-1)","marginRight":"-2px"}}>&nbsp;</div>}

              <GradCard1 className="gradient-bc-2c-2 my-16 text-left">
                  <div className="block-full font-inter fs-16 lh-none fw-600 color-highlight-2 mb-6">{item.year}</div>
                  <div className="block-full font-inter fs-20 sm:fs-24 lh-28 sm:lh-30 fw-600 color-header-3 mb-16">{item.degree}</div>
                  <div className="block-full font-inter fs-16 lh-20 fw-500 color-normal mb-16 text-italic">{item.institution}</div>
                  <div className="block-full font-inter fs-16 lh-20 fw-500 color-normal">{item.field}</div>
              </GradCard1>
              
              {_leftSide && <div className="block-0 h-0 bw-y-12 bw-l-24 bs-solid bc-transparent shrink-0 mt-48" style={{"borderLeftColor": "var(--surface-1)","marginLeft":"-2px"}}>&nbsp;</div>}
              {_leftSide && <div className="block-12 shrink-0">
                <div className="block-4  h-full absolute left-10 top-0 bg-highlight-2 shrink-0 z-index-10">&nbsp;</div>
                <div className="block-24 h-24 absolute left-0 top-48 bg-white br-full bw-4 bs-solid bc-highlight-2 shrink-0 z-index-20">&nbsp;</div>
              </div>}
            </div>
            
            {_leftSide && <div className="block-f50 shrink-0 none md:block">&nbsp;</div>}
          </div>

        })}
      </div>}
    </Section2>
  )
}

export default EducationalJourney;
